module.exports = __webpack_public_path__ + "img/data_laporan.d047f96d.png";